import { useState } from 'react'

export default function MemberFilters({ members, setFiltered }) {
  const [search, setSearch] = useState('')
  const [chapter, setChapter] = useState('')
  const [status, setStatus] = useState('')

  const chapters = [...new Set(members.map((m) => m.chapters?.name).filter(Boolean))]

  const handleFilter = (newSearch, newChapter, newStatus) => {
    let result = members
    if (newSearch) {
      result = result.filter(
        (m) =>
          m.full_name.toLowerCase().includes(newSearch.toLowerCase()) ||
          m.membership_id?.toLowerCase().includes(newSearch.toLowerCase())
      )
    }
    if (newChapter) result = result.filter((m) => m.chapters?.name === newChapter)
    if (newStatus) result = result.filter((m) => m.status === newStatus)
    setFiltered(result)
  }

  const inputClass = "bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-white/10 focus:border-green-600 text-gray-900 dark:text-white px-4 py-2.5 text-sm outline-none transition-colors placeholder:text-gray-400 dark:placeholder:text-gray-600"

  return (
    <div className="flex gap-3 mb-6 flex-wrap">
      <input
        type="text"
        placeholder="Search by name or ID..."
        value={search}
        onChange={(e) => { setSearch(e.target.value); handleFilter(e.target.value, chapter, status) }}
        className={`${inputClass} flex-1 min-w-48`}
      />
      <select
        value={chapter}
        onChange={(e) => { setChapter(e.target.value); handleFilter(search, e.target.value, status) }}
        className={inputClass}
      >
        <option value="">All Chapters</option>
        {chapters.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <select
        value={status}
        onChange={(e) => { setStatus(e.target.value); handleFilter(search, chapter, e.target.value) }}
        className={inputClass}
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  )
}